/** Shared shelf-listing constants (mirror backend provenanceCheck.util). */
export const PROVENANCE_PRICE_THRESHOLD_INR = 15000;

export const PRICING_MODES = [
  {
    id: 'fixed',
    label: 'Fixed price',
    description: 'Show a specific price to buyers',
  },
  {
    id: 'contact',
    label: 'Contact for price',
    description: 'Buyers message you for pricing',
    displayLabel: 'Contact for price',
  },
  {
    id: 'range',
    label: 'Price range',
    description: 'Show min–max range to buyers',
  },
  {
    id: 'reference',
    label: 'Market price',
    description: 'Auto-set to platform reference price',
    displayLabel: 'Market price',
  },
];

export const RESTRICTED_PART_PATTERNS = [
  /\bairbag\b/i,
  /\bsrs\b/i,
  /\becu\b/i,
  /\bbcm\b/i,
  /\bcontrol module\b/i,
  /\bpcm\b/i,
  /\becm\b/i,
  /\bcatalytic\b/i,
  /\bcat\s*con\b/i,
  /\bimmobilizer\b/i,
  /\babs module\b/i,
];

export function isRestrictedPartCategory(partName = '', partCategory = '') {
  const text = `${partCategory} ${partName}`;
  return RESTRICTED_PART_PATTERNS.some((re) => re.test(text));
}
